<template>
  <v-container>
    <v-row class="pt-6" justify="center">
      <v-col cols="8">
        <v-sheet outlined rounded="lg" class="compact-submember-form">
          <div class="d-flex align-center pa-3">
            <v-col cols="auto" class="pa-0 mr-2">
              <v-img
                src="https://drive.google.com/uc?export=view&id=1ayHBNWo0evV1zybw2TLy1kds6AORxjVc"
                max-width="28"
                contain
              >
              </v-img>
            </v-col>
            <v-col cols="10" class="pa-0">
              <span class="subtitle-2 primary-variant font-weight-black d-block">
                Registra los datos del nuevo afiliado vinculado
              </span>
              <span class="caption primary-variant mt-1 d-block">
                Luego de Registrar los datos para el nuevo afiliado vinculado,
                deberás cubrir las cuotas para el pago local y nacional
              </span>
            </v-col>
          </div>
          <v-divider></v-divider>
          <!-- Fixed fields: Datos básicos -->
          <div class="px-4 pt-1 pb-0">
            <div class="d-flex align-center mb-1">
              <v-icon x-small color="primary" class="mr-1">mdi-account-outline</v-icon>
              <span class="caption font-weight-bold primary--text">Datos básicos</span>
              <v-divider class="ml-2"></v-divider>
            </div>
            <v-row dense class="mb-0">
              <v-col cols="6" class="pr-1">
                <v-text-field
                  filled
                  rounded
                  dense
                  hide-details="auto"
                  v-model="newAffiliate.user.name"
                  label="Nombres"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pl-1">
                <v-text-field
                  filled
                  rounded
                  dense
                  hide-details="auto"
                  v-model="newAffiliate.user.firstLastname"
                  label="Apellidos"
                  prepend-inner-icon="mdi-account-outline"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              filled
              rounded
              dense
              hide-details="auto"
              v-model="newAffiliate.user.email"
              :rules="emailRules"
              label="Correo electrónico *"
              prepend-inner-icon="mdi-email-outline"
            ></v-text-field>
          </div>

          <!-- Divider between fixed and custom fields -->
          <template v-if="subMemberFormFields.length > 0">
            <div class="px-4 pb-0">
              <div class="d-flex align-center my-1">
                <v-divider></v-divider>
                <span class="caption grey--text text--darken-1 mx-2">
                  Campos adicionales
                </span>
                <v-divider></v-divider>
              </div>
            </div>
          </template>

          <!-- Custom fields configured by admin for sub-member form -->
          <div class="px-4 pb-1">
            <template v-for="(group, gi) in subMemberFormFieldGroups">
              <div
                v-if="group.title"
                :key="'section-title-' + (group._id || gi)"
                class="mt-2 mb-0"
              >
                <span class="caption font-weight-bold primary--text">{{ group.title }}</span>
                <v-divider class="mt-0"></v-divider>
              </div>
              <v-row
                v-for="field in group.fields"
                :key="(group._id || gi) + '_' + field._id"
                dense
                class="my-0"
              >
                <v-col cols="12">
                  <!-- LIST type -->
                  <v-select
                    v-if="field.fieldType === 'LIST'"
                    filled
                    rounded
                    dense
                    hide-details="auto"
                    :items="field.options"
                    :multiple="field.allowMultiple"
                    v-model="customFieldsData[field.formattedName]"
                    :label="field.name + (field.required ? ' *' : '')"
                  ></v-select>
                  <!-- NUMBER type -->
                  <v-text-field
                    v-else-if="field.fieldType === 'NUMBER'"
                    filled
                    rounded
                    dense
                    hide-details="auto"
                    type="number"
                    v-model="customFieldsData[field.formattedName]"
                    :label="field.name + (field.required ? ' *' : '')"
                  ></v-text-field>
                  <!-- DATE type -->
                  <v-text-field
                    v-else-if="field.fieldType === 'DATE'"
                    filled
                    rounded
                    dense
                    hide-details="auto"
                    type="date"
                    v-model="customFieldsData[field.formattedName]"
                    :label="field.name + (field.required ? ' *' : '')"
                  ></v-text-field>
                  <!-- TEXT / default type -->
                  <v-text-field
                    v-else
                    filled
                    rounded
                    dense
                    hide-details="auto"
                    v-model="customFieldsData[field.formattedName]"
                    :label="field.name + (field.required ? ' *' : '')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          </div>

          <div class="d-flex justify-end px-4 py-2" style="gap:8px">
            <v-btn small rounded text @click="$emit('cancel')">
              <span class="caption"> Cancelar </span>
            </v-btn>
            <v-btn
              small
              rounded
              color="primary"
              class="white--text"
              @click="AddAffiliate(false)"
            >
              <span class="caption"> Crear y salir </span>
              <v-icon size="14" class="ml-2"> mdi-content-save </v-icon>
            </v-btn>
            <v-btn
              v-if="disableSubmemberPayment"
              small
              rounded
              color="primary"
              class="white--text"
              @click="AddAffiliate(true)"
            >
              <span class="caption"> Crear e iniciar pago </span>
              <v-icon size="12" class="ml-2"> mdi-arrow-expand-right </v-icon>
            </v-btn>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { retrieveMemberAffiliationDetails } from "../../../../common/hook/useHelper";
import { groupFieldsBySection } from "@/utils";
import { validations } from "@/share/validations.js";
import { resolveMemberAffiliateBranch } from "@/common/memberDashboardRouting";
export default {
  name: "RegisterForm",
  data() {
    return {
      newAffiliate: {
        user: {
          name: "",
          firstLastname: "",
          email: "",
        },
        customFields: {},
      },
      subMemberFormFields: [],
      formSections: [],
      customFieldsData: {},
      emailRules: validations.emailValidation({ name: "correo electrónico", required: true }),
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("membershipProfile", ["userMembership"]),
    disableSubmemberPayment() {
      const { affiliationType: nationalAffiliationDetails } = retrieveMemberAffiliationDetails({
        user: this.user,
        affiliationLevel: "national",
      });

      return !!nationalAffiliationDetails?.sublevelPriceConfig?.active
    },
    // Groups the submember form fields by section (following the org's
    // registration form ordering) so the create form renders section titles.
    subMemberFormFieldGroups() {
      return groupFieldsBySection(this.formSections, this.subMemberFormFields).filter(
        (group) => group.fields && group.fields.length > 0
      );
    },
  },
  async created() {
    try {
      const orgId = this.user?.headOffice?._id || this.user?.headOffice;
      if (orgId) {
        const [result, sectionsRes] = await Promise.all([
          this.getSubMemberFormFields(orgId),
          this.getFormSectionsByOrg(orgId),
        ]);
        if (result.status) {
          this.subMemberFormFields = result.data.registrationFields || [];
        }
        if (sectionsRes && sectionsRes.status) {
          this.formSections = sectionsRes.data.sections || [];
        }
      }
    } catch (e) {
      console.error('Error loading sub-member form fields', e);
    }
  },
  methods: {
    ...mapActions("memberAffiliates", [
      "getAffiliates",
      "addAffiliate",
      "deleteAffiliate",
      "updateAffiliate",
    ]),
    ...mapActions("user", ["realoadUserData"]),
    ...mapActions("registrationFields", ["getSubMemberFormFields"]),
    ...mapActions("formSections", ["getFormSectionsByOrg"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),

    async AddAffiliate(continuePayment) {
      try {
        const email = this.newAffiliate.user.email || "";
        const emailValid = this.emailRules.every((rule) => rule(email) === true);
        if (!emailValid) {
          this.show({ text: "El correo electrónico es obligatorio y debe ser válido", color: "error" });
          return;
        }

        this.loading();

        // Build customFields from dynamic form values
        const customFields = {};
        this.subMemberFormFields.forEach(field => {
          const val = this.customFieldsData[field.formattedName];
          if (val !== undefined && val !== null && val !== '') {
            customFields[field.formattedName] = val;
          }
        });
        this.newAffiliate.customFields = customFields;

        const affiliate = await this.addAffiliate({
          affiliate: this.newAffiliate,
          organization: this.user.headOffice._id,
          branch: resolveMemberAffiliateBranch(this.user, this.userMembership),
        });
        console.log(affiliate);
        if (affiliate.status) {
          this.show({ text: "Submiembro/Colaborador creado exitosamente", color: "green" });
          if (continuePayment) {
            const user = affiliate.affiliate;
            this.$router.push(
              `/member/newAffiliate/2/${user._id}/${this.userMembership.organization._id}`
            );
          } else {
            //await this.realoadUserData({ email: this.user.email });
            this.$emit("cancel");
          }
        } else {
          this.show({
            text: affiliate.message,
            color: "red",
          });
          this.$emit("error");
        }
        this.loaded();
      } catch (error) {
        console.log(error);
      } finally {
        this.loaded();
      }
    },
  },
};
</script>

<style scoped>
.compact-submember-form >>> .v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot {
  min-height: 28px;
}
.compact-submember-form >>> .v-text-field--filled.v-input--dense .v-input__slot input {
  padding: 4px 0 4px;
  font-size: 14px;
}
.compact-submember-form >>> .v-text-field--filled.v-input--dense .v-label {
  font-size: 13px;
}
.compact-submember-form >>> .v-text-field--filled.v-input--dense .v-label--active {
  transform: translateY(-14px) scale(0.85);
}
.compact-submember-form >>> .v-input__prepend-inner {
  margin-top: 3px;
}
.compact-submember-form >>> .v-input__prepend-inner .v-icon {
  font-size: 18px;
}
.compact-submember-form >>> .v-select--filled.v-input--dense .v-select__slot {
  font-size: 14px;
}
.compact-submember-form >>> .v-text-field--rounded.v-input--dense > .v-input__control > .v-input__slot {
  border-radius: 8px;
}
</style>
